import { lazy } from 'react';

export const PlayerNameForm = lazy(() => import('./PlayerNameForm'));
